<ng-template #content>
    @if (iconPrefixId && !iconPrefixId.startsWith('evida_')) {
        <mat-icon class="evida-button-prefix-icon">
            {{ iconPrefixId }}
        </mat-icon>
    }
    @if (iconPrefixId && iconPrefixId.startsWith('evida_')) {
        <mat-icon class="evida-button-prefix-icon" [svgIcon]="iconPrefixId"> </mat-icon>
    }
    <ng-content></ng-content>
    @if (iconSuffixId && !iconSuffixId.startsWith('evida_')) {
        <mat-icon class="evida-button-suffix-icon">{{ iconSuffixId }}</mat-icon>
    }
    @if (iconSuffixId && iconSuffixId.startsWith('evida_')) {
        <mat-icon class="evida-button-suffix-icon" [svgIcon]="iconSuffixId"></mat-icon>
    }
</ng-template>

<div [class]="'evida-button testdenher px-0 ' + widthClass">
    @switch (type) {
        @case ('back') {
            <button
                [tabindex]="[tabindex]"
                mat-raised-button
                class="evida-button-back-button h-auto sm:h-50px w-full"
                [disabled]="disabled"
                (click)="clicked.emit(null)"
                type="button"
            >
                <mat-icon color="primary" class="evida-button-prefix-icon">chevron_left</mat-icon>
                <ng-container *ngTemplateOutlet="content"></ng-container>
            </button>
        }
        @case ('forward') {
            <button
                [tabindex]="[tabindex]"
                mat-raised-button
                class="evida-button-forward-button h-auto sm:h-50px w-full"
                [disabled]="disabled"
                (click)="clicked.emit(null)"
                type="button"
            >
                <ng-container *ngTemplateOutlet="content"></ng-container>
                <mat-icon color="primary" class="evida-button-suffix-icon">chevron_right</mat-icon>
            </button>
        }
        @case ('round') {
            <button
                [tabindex]="[tabindex]"
                mat-raised-button
                class="evida-button-round-button h-auto sm:h-50px w-full"
                [disabled]="disabled"
                (click)="clicked.emit(null)"
                type="button"
            >
                <ng-container *ngTemplateOutlet="content"></ng-container>
            </button>
        }
        @case ('primary') {
            <button
                [tabindex]="[tabindex]"
                mat-stroked-button
                color="primary"
                [disabled]="disabled"
                (click)="clicked.emit(null)"
                class="px-20px mr-10px h-auto sm:h-50px w-full"
                type="button"
            >
                <ng-container *ngTemplateOutlet="content"></ng-container>
            </button>
        }
        @case ('secondary') {
            <button
                [tabindex]="[tabindex]"
                mat-stroked-button
                color="secondary"
                [disabled]="disabled"
                (click)="clicked.emit(null)"
                class="px-20px mr-10px h-auto sm:h-50px w-full"
                type="button"
            >
                <ng-container *ngTemplateOutlet="content"></ng-container>
            </button>
        }
        @case ('secondary_no_border') {
            <button
                [tabindex]="[tabindex]"
                mat-stroked-button
                class="mat-secondary-no-border px-20px mr-10px h-auto sm:h-50px w-full"
                [disabled]="disabled"
                (click)="clicked.emit(null)"
                type="button"
            >
                <ng-container *ngTemplateOutlet="content"></ng-container>
            </button>
        }
        @case ('secondary_orange') {
            <button
                [tabindex]="[tabindex]"
                mat-stroked-button
                class="fg-darkOrange h-auto sm:h-50px w-full"
                [disabled]="disabled"
                (click)="clicked.emit(null)"
                type="button"
            >
                <ng-container *ngTemplateOutlet="content"></ng-container>
            </button>
        }
        @case ('tertiary') {
            <button
                [tabindex]="[tabindex]"
                mat-raised-button
                color="tertiary"
                class="px-20px mr-10px w-full tertiary-button"
                [disabled]="disabled"
                (click)="clicked.emit(null)"
                type="button"
            >
                <ng-container *ngTemplateOutlet="content"></ng-container>
            </button>
        }
        @case ('quaternary') {
            <button
                [tabindex]="[tabindex]"
                mat-flat-button
                color="quaternary"
                class="bg-petroleum5pct w-full"
                [disabled]="disabled"
                (click)="clicked.emit(null)"
                type="button"
            >
                <ng-container *ngTemplateOutlet="content"></ng-container>
            </button>
        }
        <!-- Button made specifically for the toolbar -->
        @case ('toolbar') {
            <button
                [tabindex]="[tabindex]"
                mat-stroked-button
                color="secondary"
                [disabled]="disabled"
                (click)="clicked.emit(null)"
                class="px-20px mr-10px h-auto sm:h-40px md:h-50px w-full"
                type="button"
            >
                <ng-container *ngTemplateOutlet="content"></ng-container>
            </button>
        }
        @case ('info') {
            <mat-icon
                [tabindex]="[tabindex]"
                class="cursor-pointer ml-10px"
                svgIcon="evida_state_information"
                inline="true"
                (click)="clicked.emit()"
            >
            </mat-icon>
        }
        @default {
            <span style="color: red">
                <button
                    [tabindex]="[tabindex]"
                    title="Unhandled enum value for {{ type }}"
                    mat-flat-button
                    color="primary"
                    class="bg-petroleum5pct error w-full"
                    [disabled]="disabled"
                    (click)="clicked.emit(null)"
                    type="button"
                >
                    <ng-container *ngTemplateOutlet="content"></ng-container>
                </button>
            </span>
        }
    }
</div>
